import React, { useEffect, useState } from 'react';
import UploadFile from '../../../components/Request/UploadFile';
import {
  getCurrentPage,
  requestsSelector,
  setCurrentRequestFilesSize,
  setLoading,
  setNextButtonEnabled,
  setRequestData,
} from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import styles from './FullProduct.module.scss';
import cx from 'classnames';
import { getFileFormData, setDefaultFiles, uploadRequestFile } from './helper';
import { apiDeleteRequestFile, apiPostImageOnPresignedData } from '../../../helpers/api';
import icons from '../../../assets';
import { download } from '../../../common/DownloadFileController/downloadFile';
import UploadedFiles from '../../../components/Request/UploadedFiles';
import UploadFileWrapper from '../../../components/Request/UploadFileWrapper';

function CloseUp({ isReadOnly, className = '' }) {
  const TITLE = 'Detailed Photos';
  const _requestSelector = useSelector(requestsSelector);
  const dispatch = useDispatch();
  const currentPage = useSelector(getCurrentPage);
  const [data, setData] = useState(currentPage?.data?.[TITLE] || []);

  const handleFileChange = async (_files, _title = '') => {
    if (isReadOnly) return;
    const _data = {};

    _data[_title] = _files.map((item) => {
      const imageUrl = URL.createObjectURL(item);

      return {
        name: item.name,
        filename: item.name,
        thumbnail: imageUrl,
        url: imageUrl,
        file: item,
      };
    });

    const formData = getFileFormData(_files, _requestSelector.currentRequestId, 'detailsImages');

    dispatch(setLoading(true));
    await uploadRequestFile(formData, _files, data, setData, '', false, dispatch, _requestSelector);
    dispatch(setLoading(false));
  };

  const handleFileRemove = async (_id) => {
    const _file = data.find((item) => item.id === _id);
    dispatch(
      setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize - _file.file.size)
    );

    const _files = data.filter((item) => item.id != _id);
    setData(_files);
    await apiDeleteRequestFile(_id);
  };

  useEffect(() => {
    if (_requestSelector?.currentRequestId) {
      dispatch(setNextButtonEnabled(true));
      setDefaultFiles(_requestSelector.currentRequestId, 'detailsImages', setData);
    }
  }, []);

  return (
    <div
      className={cx('d-grid gap-3 py-3', className)}
      style={
        data.length > 0
          ? {
              gridTemplateColumns: 'repeat(auto-fill, minmax(215px, 1fr))',
            }
          : {}
      }>
      {
        <UploadFileWrapper fullWidth={!data.length} hidden={isReadOnly && data.length}>
          <UploadFile
            title={TITLE}
            subtitle="Drag photos here"
            className={
              !data.length
                ? cx(
                    styles.fullWidth,
                    isReadOnly
                      ? cx(styles.heightFourHundread, styles.disabled)
                      : styles.heightFiveHundread
                  )
                : 'w-100 h-100'
            }
            uploadText={isReadOnly && 'No images added'}
            hideSubtitle={isReadOnly}
            onFileChange={handleFileChange}
            acceptMutipleFiles={true}
            subClassName={'h-100'}
            hidden={isReadOnly && data.length}
          />
        </UploadFileWrapper>
      }
      {data.map(
        (item, index) =>
          item.file && (
            <UploadedFiles
              key={index}
              _file={item}
              onDeleteClick={() => handleFileRemove(item.id)}
              variant={2}
              isReadOnly={isReadOnly}
            />
          )
      )}
    </div>
  );
}

export default CloseUp;
